import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';
import Layout from '@4c/layout';

const styles = require('./ErrorSummary-styles.module.scss');
const propTypes = {};

function ErrorSummary({ children, innerRef, className, ...props }) {
  return (
    <Layout
      {...props}
      pad={4}
      ref={innerRef}
      className={classNames(className, styles.summary)}
    >
      <svg
        aria-hidden
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill="#FFF"
          d="M8.66 4.86h2.68l-.23 6.75H8.88l-.22-6.75zm-.09 9.02c0-.81.53-1.28 1.43-1.28.9 0 1.43.47 1.43 1.28 0 .8-.53 1.26-1.43 1.26-.9 0-1.43-.46-1.43-1.26z"
          className="foreground"
        />
        <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-1.43-6.12c0 .8.53 1.26 1.43 1.26.9 0 1.43-.46 1.43-1.26 0-.81-.53-1.28-1.43-1.28-.9 0-1.43.47-1.43 1.28zm.09-9.02l.22 6.75h2.23l.23-6.75H8.66z" />
      </svg>
      <Layout.Block role="alert">{children}</Layout.Block>
    </Layout>
  );
}

ErrorSummary.propTypes = propTypes;

export default React.forwardRef((props, ref) => (
  <ErrorSummary {...props} innerRef={ref} />
));
